import * as React from 'react';
import styled from 'styled-components';
import Slides from '../../atoms/Slides';
import ThemeImage from '../../molecules/ThemeImage';

const VisualWrapper = styled.div`
  width: 1200px;
  margin: 0 auto 15px auto;
  border: 1px solid #cdcdcd;
`;

const Visual = () => {
  return (
    <VisualWrapper className="clearfix">
      <Slides />
      <ThemeImage />
    </VisualWrapper>
  );
};

export default Visual;
